import {
  BUSINESSES_DOCUMENT_TYPES_REQUEST,
  BUSINESSES_DOCUMENT_TYPES_SUCCESS,
  BUSINESSES_DOCUMENT_TYPES_FAILURE,
} from '../actions/business_document_types'

export function businessDocumentTypes(
  state = {
    isFetching: true,
    types: [],
    errorMessage: null,
  },
  action
) {
  switch (action.type) {
    case BUSINESSES_DOCUMENT_TYPES_REQUEST:
      return { ...state, isFetching: true, types: [], errorMessage: null }
    case BUSINESSES_DOCUMENT_TYPES_SUCCESS:
      return { ...state, isFetching: false, types: action.response, errorMessage: null }
    case BUSINESSES_DOCUMENT_TYPES_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.error }
    default:
      return state
  }
}
